export default __webpack_public_path__ + "static/media/momni_desktop.e2e08d59.jpg";